import { render, staticRenderFns } from "./blocking_merge_requests_report.vue?vue&type=template&id=7a368edd"
import script from "./blocking_merge_requests_report.vue?vue&type=script&lang=js"
export * from "./blocking_merge_requests_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports